import { ErrorHandler, Injectable, inject } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from "../../environments/environment";

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  private _snackBar = inject(MatSnackBar);

  override handleError(error: any): void {
    console.log('🚨 AppErrorHandler caught an error:', error);

    // Chama o handler padrão do Angular primeiro para garantir que o erro seja logado
    super.handleError(error);

    // FILTRA APENAS ERROS HTTP (Fetch/XHR)
    if (this.isHttpError(error)) {
      this.handleHttpError(error);
    }
    // Ignora todos os outros tipos de erro (JavaScript, etc.)
  }

  private isHttpError(error: any): boolean {
    // Verifica se é uma instância de HttpErrorResponse
    if (error instanceof HttpErrorResponse) {
      return true;
    }

    // Verifica se é um erro HTTP encapsulado
    if (error?.error instanceof HttpErrorResponse) {
      return true;
    }

    // Verifica se tem propriedades típicas de erro HTTP
    if (error?.status && typeof error.status === 'number') {
      return true;
    }

    // Verifica se o erro interno tem propriedades HTTP
    if (error?.error?.status && typeof error.error.status === 'number') {
      return true;
    }

    return false;
  }

  private handleHttpError(error: any): void {
    // Normaliza o erro para sempre ter o HttpErrorResponse
    const httpError = error instanceof HttpErrorResponse ? error :
      error?.error instanceof HttpErrorResponse ? error.error :
        error?.error?.status ? error.error : error;

    const status = httpError.status;

    console.log(`🌐 HTTP Error ${status}:`, httpError);

    switch (status) {
      case 404:
        const message404 = httpError?.error?.message || 'Recurso não encontrado';
        this._snackBar.open(message404, 'Fechar', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        break;

      case 500:
        if (!environment.production) {
          console.error('🔥 Erro interno do servidor:', httpError);
        }
        break;

      case 409:
        console.error('⚠️ Erro de conflito:', httpError);
        const message409 = httpError?.error?.message || 'Dados já existem ou conflito na operação';
        this._snackBar.open(message409, 'Fechar', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        break;

      case 403:
        const message403 = httpError?.error?.message || 'Você não tem permissão para acessar este recurso';
        this._snackBar.open(message403, 'Fechar', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        break;

      case 401:
        this._snackBar.open('Sessão expirada. Faça login novamente.', 'Fechar', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        break;

      case 400:
        const message400 = httpError?.error?.message || 'Dados inválidos na requisição';
        this._snackBar.open(message400, 'Fechar', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        break;

      case 422:
        const message422 = httpError?.error?.message || 'Dados não puderam ser processados';
        this._snackBar.open(message422, 'Fechar', {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
        break;

      default:
        console.error(`❌ Erro HTTP ${status}:`, httpError);
        break;
    }
  }
}